import { render, staticRenderFns } from "./detailsFactorySupplyList.vue?vue&type=template&id=7645b2d2&scoped=true"
import script from "./detailsFactorySupplyList.vue?vue&type=script&lang=js"
export * from "./detailsFactorySupplyList.vue?vue&type=script&lang=js"
import style0 from "./detailsFactorySupplyList.vue?vue&type=style&index=0&id=7645b2d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645b2d2",
  null
  
)

export default component.exports